import { HourFormat, WeekDay } from '@mews/enums';

export interface DateTimeLocalizationInfo {
    cultureCode: string;
    timeFormat: string;
    timeShortFormat: string;
    dateFormat: string;
    dateShortFormat: string;
    dateShortMonthDayFormat: string;
    dateLongFormat: string;
    dateTimeFormat: string;
    hourFormat: HourFormat;
    weekStart: WeekDay;
    anteMeridiem: string;
    postMeridiem: string;
    monthNames: [string, string, string, string, string, string, string, string, string, string, string, string];
    monthShortNames: [string, string, string, string, string, string, string, string, string, string, string, string];
    dayNames: [string, string, string, string, string, string, string];
    dayShortNames: [string, string, string, string, string, string, string];
}

export interface NumberFormatting {
    decimalSeparator: string;
    groupSeparator: string;
}

export enum SymbolSpacing {
    None = 'None',
    Single = 'Single',
}

export enum SymbolPosition {
    Prefix = 'Prefix',
    Suffix = 'Suffix',
}
